import React from "react";
import PropTypes from "prop-types";

import { TopNav } from "../topnav";
import { LeftNav } from "../leftnav/leftnav";

import styles from "./layout.css";

export function Layout({ children, topMenu }) {
  return (
    <div className={styles.home}>
      <TopNav topMenu={topMenu} />
      <div className={styles.contentcontainer}>
        <LeftNav />
        <div
          className={`${styles.content} base ${
            window.isLeftNavEnabled ? styles.leftnavEnabled : ""
          }`}
        >
          {children}
        </div>
      </div>
      <div id="chatbuttoncontainer" />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  topMenu: PropTypes.element
};
